
const PaymentInfo = () => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h2 className="text-lg font-semibold mb-4">Payment Information</h2>
      <div className="space-y-2 text-gray-600 text-sm">
        <p>• All payments are processed securely via Razorpay.</p>
        <p>• We accept Credit/Debit Cards, UPI, Netbanking and Wallets.</p>
        <p>• You'll receive an email receipt after successful payment.</p>
        <p>• For payment issues, please contact careerguidekerala@gmail.com</p>
      </div>
    </div>
  );
};

export default PaymentInfo;
